const TYPE_INTRODUCTION_LGPD = 'INTRODUCTION_LGPD'
const TYPE_FUNDAMENTAL_CONCEPTS = 'FUNDAMENTAL_CONCEPTS'
const TYPE_CLEAN_TABLE_AND_SCREEN = 'CLEAN_TABLE_AND_SCREEN'
const TYPE_ARTIFICIAL_INTELLIGENCE = 'ARTIFICIAL_INTELLIGENCE'
const TYPE_PRIVACY_BY_DESIGN = 'PRIVACY_BY_DESIGN'

const LABEL_INTRODUCTION_LGPD = 'Introdução à LGPD'
const LABEL_FUNDAMENTAL_CONCEPTS = 'Conceitos Fundamentais'
const LABEL_CLEAN_TABLE_AND_SCREEN = 'Mesa e Tela Limpa'
const LABEL_ARTIFICIAL_INTELLIGENCE = 'Inteligência Artificial'
const LABEL_PRIVACY_BY_DESIGN = 'Privacy by Design'

const STAMP = 'Selo'
const CERTIFICATE = 'Certificado'

const CERTIFICATES = {
  FUNDAMENTAL_CONCEPTS: {
    label: 'Conceitos fundamentais da LGPD',
    status: 'Pendente',
  },
  INTRODUCTION_LGPD: {
    label: 'Introdução à LGPD',
    status: 'Pendente',
  },
}

const TRANSLATE_TYPES = {
  [TYPE_INTRODUCTION_LGPD]: LABEL_INTRODUCTION_LGPD,
  [TYPE_FUNDAMENTAL_CONCEPTS]: LABEL_FUNDAMENTAL_CONCEPTS,
  [TYPE_CLEAN_TABLE_AND_SCREEN]: LABEL_CLEAN_TABLE_AND_SCREEN,
  [TYPE_ARTIFICIAL_INTELLIGENCE]: LABEL_ARTIFICIAL_INTELLIGENCE,
  [TYPE_PRIVACY_BY_DESIGN]: LABEL_PRIVACY_BY_DESIGN,
}

const TRAINING_JOURNEY_TRAILS = [
  TYPE_FUNDAMENTAL_CONCEPTS,
  TYPE_CLEAN_TABLE_AND_SCREEN,
  TYPE_ARTIFICIAL_INTELLIGENCE,
  TYPE_PRIVACY_BY_DESIGN,
]

const trailsJourney = {
  STAMP,
  CERTIFICATES,
  CERTIFICATE,
  TRANSLATE_TYPES,
  TYPE_INTRODUCTION_LGPD,
  TYPE_FUNDAMENTAL_CONCEPTS,
  TYPE_CLEAN_TABLE_AND_SCREEN,
  TYPE_ARTIFICIAL_INTELLIGENCE,
  TYPE_PRIVACY_BY_DESIGN,
  LABEL_INTRODUCTION_LGPD,
  LABEL_FUNDAMENTAL_CONCEPTS,
  LABEL_CLEAN_TABLE_AND_SCREEN,
  LABEL_ARTIFICIAL_INTELLIGENCE,
  LABEL_PRIVACY_BY_DESIGN,
  TRAINING_JOURNEY_TRAILS,
}

export default trailsJourney
